var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center h-screen bg-ontick-carbon-500"},[_c('h1',{staticClass:"text-9xl font-bold mb-4 text-ontick-steel-400"},[_vm._v("404")]),_c('p',{staticClass:"text-xl text-gray-400"},[_vm._v("Página não encontrada.")])])
}]

export { render, staticRenderFns }